module.exports = __webpack_public_path__ + "img/aeroland-macbook-01.ca95ee01.png";